module.exports = __webpack_public_path__ + "img/aeroland-ebook-image-03.3015a7d5.jpg";